<template lang="pug">
select.form-control(v-model="selectedValue")
  option(v-for="(value, name) in allOptions" :value="value" v-text="name" :key="value")
</template>

<script>
  import { computed } from 'vue'

  export default {
    props: {
      value: null,
      // Format: { label: 'value' }
      options: {
        type: Object,
        default: () => { {} }
      },
      blankOptionName: {
        type: String,
        required: false
      }
    },

    setup(props, { emit }) {
      const allOptions = computed(() => {
        if (!props.blankOptionName) return props.options

        return {
          [props.blankOptionName]: null,
          ...props.options
        }
      })

      const selectedValue = computed({
        get() {
          return props.value
        },
        set(value) {
          // Value comes across as a string because it comes from the HTML attribute value.
          // So we find the matching entry to get the right data type.
          const realValue = Object.values(props.options).find(
            val => String(val) === String(value)
          )
          emit('input', realValue)
        }
      })

      return {
        allOptions,
        selectedValue
      }
    }
  }
</script>
